import React, { useContext, useEffect, useState } from 'react'
import SearchBarWithFilters from "components/search_with_filters";
import { Box, FormControl, Grid, InputBase, makeStyles, MenuItem, Paper, Select, Typography, useTheme } from '@material-ui/core';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import { getBaseStationID, getOrganisationId } from 'lib/utils/common_utils';
import MultipleBaseFilter from 'components/MultipleBaseFilter';
import ReactApexChart from 'react-apexcharts';
import { StoreDashboardServices } from 'lib/services/api/dashboard/stores';
import _ from 'lodash';
import ChartLoader from 'views/Dashboard/Workshops/Storage/ChartLoader';
import StopIcon from '@material-ui/icons/Stop';
import tableIcons, { options } from 'components/universal/table_attributes';
import MaterialTable from 'material-table';
import { ToastMessageContext } from 'lib/contexts/message_context';





const useStyles = makeStyles((theme) => ({

    formWrapper: {
        width: "95%",
        margin: "0% 3%",

    },
    lengends: {
        marginTop: "3px",
        fontSize: "13px"
    },

}))




export default function OilAccuracy(props) {

    const classes = useStyles()
    const [selectedBase, setSelectedBase] = useState([getBaseStationID()]);
    const theme = useTheme()
    const primary = theme.palette.primary.main
    const secondary = theme.palette.secondary.main
    const [filterData, setFilterData] = useState("accuracy");
    const [acc_data, setAccData] = useState([])
    const [value_data, setValData] = useState([])
    const [var_data, setVarData] = useState([])
    const [xAxis, setXAxis] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalCount, setTotalCount] = useState(10)
    const [data, setData] = useState([])
    const message = useContext(ToastMessageContext)
    const [busy, setBusy] = useState(false)
    const [state, setState] = useState({
        series: [],

        options: {
            chart: {
                type: 'line',
                height: 350,
                stacked: false,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                },

            },
            stroke: {
                width: [2, 0, 0, 0]
            },
            colors: [`${primary}`, `${secondary}`],
            // colors: [`${theme.palette.secondary.main}`],

            dataLabels: {
                enabled: false
            },

            xaxis: {
                // type: 'datetime',
                labels: {
                    show: true,
                }

            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    rotate: 0,
                },
            },

            grid: {
                show: true,
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
            },
            responsive: [{
                breakpoint: 480,

            }],


            legend: {
                show: false
            },
            fill: {
                opacity: 1
            }
        },


    })

    const getDetails = async () => {

        const params = {
            organisation_id: getOrganisationId(),

        }
        selectedBase.forEach((item, index) => params[`base_station_id[${[index]}]`] = item)
        setLoading(true)
        await StoreDashboardServices.getOilGraphDetails(params).then((res) => {

            let value = res?.data

            let acc = [{ name: "Accuracy", data: value.map((item) => item.accuracy) }]
            let f_value = [{ name: "Work Order Quarts", data: value.map((item) => item.wo_count) }, { name: "Stock Transactions", data: value.map((item) => item.tx_count) }]
            let varian = [{
                name: "Variance", data: value.map((item) => item.variance)
            }]
            setXAxis(value.map((item) => item.display_date))
            setAccData(acc)
            setValData(f_value)
            setVarData(varian)

            setState(prevState => {

                const updatedState = _.clone(prevState)
                return {
                    ...updatedState,
                    series: acc, options: {
                        ...updatedState.options,
                        xaxis: {
                            categories: value.map((item) => item.display_date), labels: {
                                show: true,
                            }
                        }
                    }
                }
            })
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    }


    useEffect(() => {
        getDetails()
    }, [selectedBase])



    useEffect(() => {

        let data = filterData === "accuracy" ? acc_data : filterData === "value" ? value_data : filterData === "variance" ? var_data : []

        setState(prevState => {

            const updatedState = _.clone(prevState)
            return {
                ...updatedState,
                series: data, options: {
                    ...updatedState.options,
                    xaxis: {
                        categories: xAxis, labels: {
                            show: true,
                        }
                    }
                },
            }
        })




    }, [filterData])

    // Table
    const tableOptions = {
        ...options,
        page: page,
        search: false,
        total: totalCount,
        pageSize: pageSize,
        toolbar: false,
    };

    const columns = [

        {
            title: "Base",
            field: "station",
            width: "4%",
            headerStyle: {
                width: "4%",
                textAlign: "left",
            },
            cellStyle: {
                textAlign: "left",
                width: "4%",
            },
        },


        {
            title: "Item",
            field: "item",
            width: "54%",
            headerStyle: {
                textAlign: "left",
                width: "54%",
            },
            cellStyle: {
                textAlign: "left",
                width: "54%",
            }
        },
        {
            title: "12 Months",
            field: "12_months",

        },
        {
            title: "6 Months",
            field: "6_months",

        },
        {
            title: "3 Months",
            field: "3_months",


        },
        {
            title: "1 Months",
            field: "1_month",


        },

    ]

    const getTableDetails = async () => {



        const params = {
            page: page + 1,
            limit: pageSize,
            organisation_id: getOrganisationId(),

        }
        setBusy(true)
        selectedBase.forEach((item, index) => params[`base_station_id[${[index]}]`] = item)
        await StoreDashboardServices.getOilTableDetails(params).then((response) => {

            if (response.success) {

                let data = response.data

                if (data.length > 0) {
                    const periods = ["last_12_months", "last_6_months", "last_3_months", "last_1_month"];
                    const metrics = ["wo_count", "tx_count", "variance"];

                    let array = data.map((item) => {
                        return {
                            station: item.station,
                            item: "Accuracy",
                            ...Object.fromEntries(periods.map(period => [period.replace("last_", ""), `${item[period].accuracy}%`])),
                            line_items: metrics.map(metric => ({
                                item: metric === "wo_count" ? "Work Order Quarts" : metric === "tx_count" ? "Stock Transactions" : metric === "variance" && "Variance",
                                ...Object.fromEntries(periods.map(period => [period.replace("last_", ""), item[period][metric]])),
                            })),
                        }
                    })



                    setData(array)



                } else {
                    setData([])
                }

                setTotalCount(response.total_count)
            }


        }).catch((error) => {
            message.showToastMessage({ message: error.errors ? error.errors.join(', ') : "Something went wrong. Try again!", variant: "error" })

        }).finally(() => {
            setBusy(false)
        })



    }




    useEffect(() => {
        getTableDetails()
    }, [page, pageSize, selectedBase])





    return (
        <div className={classes.formWrapper}>

            <SearchBarWithFilters noSearch padding={'4px 8px'}
            >
                <MultipleBaseFilter selectedBase={selectedBase} setSelectedBase={setSelectedBase} />
            </SearchBarWithFilters>
            <Typography variant="h6" style={{ paddingBottom: '10px' }}>Line Maint Oil Transactions</Typography>







            <Paper >

                <Grid container style={{ padding: "14px 6px 3px 15px" }}>
                    <Grid item xs={5}>     <Typography variant="subtitle2" color="primary">Last 12 Months</Typography></Grid>

                    <Grid xs={6} container>
                        <Grid xs={filterData === "value" ? 6 : 9}></Grid>
                        <Grid container xs={3}>

                            <Grid ><StopIcon htmlColor={primary} /></Grid>
                            <Grid className={classes.lengends}>{filterData === "accuracy" ? "Accuracy" : filterData === "variance" ? "Variance" : filterData === "value" && "Stock Transaction"}</Grid>
                        </Grid>
                        {filterData === "value" && <Grid container xs={3}>

                            <Grid ><StopIcon htmlColor={secondary} /></Grid>
                            <Grid className={classes.lengends}>Stock Transaction </Grid>
                        </Grid>}




                    </Grid>

                    <Grid xs={1} style={{ marginTop: '-2px' }}>   <FormControl size="medium" className={"filter"}>
                        <Select
                            fullWidth
                            displayEmpty
                            onChange={(e) => {

                                setFilterData(e.target.value)
                            }}
                            id="tags-standard"
                            name=""
                            value={filterData}
                            defaultValue={"otp"}
                            input={<InputBase />}
                        >
                            <MenuItem value={"accuracy"}>Accuracy</MenuItem>
                            <MenuItem value={"value"}>Values</MenuItem>
                            <MenuItem value={"variance"}>Variance</MenuItem>

                        </Select>
                    </FormControl></Grid>

                </Grid>
                <Grid>


                    {loading ? <ChartLoader /> :
                        <Box width="100%" display="flex" >
                            <Box width="98%">
                                <ReactApexChart
                                    options={state.options}
                                    series={state.series}
                                    type="line"
                                    height={350}
                                />
                            </Box>
                        </Box>}


                </Grid>






            </Paper>



            <Typography variant="h6" style={{ padding: '10px 10px' }}>Station Overview</Typography>



            <MaterialTable
                style={{ marginTop: 20 }}
                columns={columns}
                icons={tableIcons}
                title=""
                data={data || []}
                isLoading={busy}
                options={tableOptions}
                onChangePage={(page) => {
                    setPage(page);
                }}
                onChangeRowsPerPage={(pageSize) => {
                    setPageSize(pageSize);
                }}

                totalCount={totalCount}
                page={page}
                detailPanel={(rowData) => !rowData?.line_items?.length ? (
                    <div
                        style={{
                            marginLeft: "120px",
                            wordWrap: "break-word",
                            opacity: "50%",
                            padding: "10px",
                        }}
                    >
                        <span style={{ fontSize: "14px" }}>
                            No Records Found
                        </span>
                    </div>
                ) : (


                    <div >
                        <MaterialTable
                            style={{ boxShadow: 'none' }}
                            icons={tableIcons}
                            title={""}
                            // classes={{
                            //     table: { tableLayout: "fixed" },
                            //     row: { padding: "0" },
                            //     cell: {
                            //         padding: "8px",
                            //         wordBreak: 'break-word',
                            //     },
                            //     header: {
                            //         padding: "8px",
                            //     },
                            // }}
                            columns={[{
                                title: "Base",
                                field: "station",
                                width: "7%",
                                headerStyle: {
                                    width: "7%",
                                    textAlign: "left",
                                },
                                cellStyle: {
                                    textAlign: "left",
                                    width: "7%",
                                },
                            },


                            {
                                title: "Item",
                                field: "item",
                                width: "55%",
                                headerStyle: {
                                    textAlign: "left",
                                    width: "55%",
                                },
                                cellStyle: {
                                    textAlign: "left",
                                    width: "55%",
                                }
                            },
                            {
                                title: "12 Months",
                                field: "12_months",

                            },
                            {
                                title: "6 Months",
                                field: "6_months",

                            },
                            {
                                title: "3 Months",
                                field: "3_months",


                            },
                            {
                                title: "1 Months",
                                field: "1_month",


                            }]}
                            data={rowData?.line_items || []}
                            isLoading={busy}
                            options={{
                                ...options,
                                toolbar: false,
                                paging: false,
                                header: false,
                                padding: "dense",
                                tableLayout: "fixed",

                            }}
                        />


                    </div>)










                }



            />





        </div>
    )
}
